<template>
  <div class="review-sec mb-0 pb-0">
    <div class="review-header">
      <h4>معرض الصور</h4>
    </div>
    <div class="gallery-list">
      <ul>
        <li
          v-for="(image, index) in carImages"
          :key="index"
          @click="() => show(index)"
          data-aos="fade-down"
        >
          <div class="gallery-widget">
            <a href="javascript:;" data-fancybox="gallery1">
              <img class="img-fluid" alt="Image" :src="image?.image" />
            </a>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <vue-easy-lightbox
    :visible="visible"
    :index="index"
    :imgs="
      carImages?.map((image) => ({
        src: image?.image,
        alt: image?.name || 'Gallery Image',
      }))
    "
    @hide="visible = false"
    @on-prev="handlePrev"
    @on-next="handleNext"
  >
  </vue-easy-lightbox>
</template>
<script>
import VueEasyLightbox from "vue-easy-lightbox";
export default {
  components: {
    VueEasyLightbox,
  },
  props: {
    carImages: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      visible: false,
      index: 0,
    };
  },
  methods: {
    show(index) {
      this.index = index;
      this.visible = true;
    },
    handlePrev() {},
    handleNext() {},
  },
};
</script>

<style>
.gallery-widget img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 8px;
}
</style>
